import { GET_DEMOGRAPHICS } from "./actionTypes";

// eslint-disable-next-line 
export default (state = {}, action) => {
    switch(action.type) {
       case GET_DEMOGRAPHICS:
          return action.payload;
       default:
          return state;  
    }
  }